<template>
  <div class="group-detail">
    <div class="content-wrapper">
      <div class="main-content">
        <div class="main-content__msg-box">
          <ErrorCsv :errorMessages="errorMessages" />
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col text-center">
            <b-button pill variant="primary" @click="confirm">Import</b-button>
          </div>
        </div>
      </div>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import ErrorCsv from '@/components/parts/ErrorCsv.vue'
import Loading from '@/components/parts/modal/Loading.vue'
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import { AssignmentStatus } from '@/store/groups/formation/types'

@Component({
  components: {
    ErrorCsv,
    Loading,
  },
})
export default class ReflectLMS extends Vue {
  @Prop({ required: true }) selectedAssignment!: AssignmentStatus

  errorMessages: string[] = []

  isLoading: boolean = false

  /**
   * バリデーション＋確認
   */
  async confirm() {
    const isConfirmed = await this.$bvModal.msgBoxConfirm('Reflection groups to LMS. OK?')
    if (isConfirmed) {
      this.reflectionLms()
    }
  }

  /**
   * LMSにグループデータ連携
   */
  async reflectionLms() {
    if (this.isLoading) return
    this.isLoading = true

    try {
      await this.$store.dispatch('sendGroupsToLms', {
        assignment: this.selectedAssignment,
      })
      this.isLoading = false
      await this.$bvModal.msgBoxOk('Success !')
      this.$emit('complete')
    } catch (error: any) {
      this.isLoading = false
      this.errorMessages = [error]
      if (error.response) {
        let errors = _.chain(error.response)
          .get('data.message').value()
        if (_.some(errors, (o) => _.has(o, 'message'))) {
          errors = errors
            .map(({ index, message }: { index: number, message: string}) => `row ${index} group has error: ${message}`)
        }
        this.errorMessages = Array.isArray(errors) ? errors : [errors]
      }
    }
  }

  checkError(error: string[]) {
    this.errorMessages = error
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;

  p {
    display: block;
    text-align: left;
    margin:10px 0;
    font-weight: bold;
    text-align: left;
    margin:10px 0;
    font-weight: bold;
  }

  .csv-box {
    margin-bottom:70px;
    padding-right: 30px;
    padding-left: 30px;
  }
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 20px;
}
</style>
